import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect }  from 'react-redux';
import { followUser } from '../../actions/profile/follow';

function FollowBtn(props) {
    const [processing, setProcessing] = useState(false),
        { profileId,
            className,
            isCurrentUser,
            token,
            isPublic,
            publicClickAction,
            followUser,
            isDisabled } = props;
    const _followUser = (e) => {
        if (isPublic) {
            if (publicClickAction && typeof publicClickAction === "function") {
                publicClickAction();
            }
            return;
        }
        if (processing) return;
        setProcessing(true);
        followUser(profileId,
            token,
            isCurrentUser || false)
            .then(_ => {
                if (!_) {
                    setProcessing(false);
                }
            });
    }
    return (<button className={className || ''}
        disabled={isDisabled || processing}
        onClick={_followUser}>
        {props.children}
    </button>)
};

FollowBtn.propTypes = {
    profileId: PropTypes.number,
    isDisabled: PropTypes.bool,
    isCurrentUser: PropTypes.bool,
    className: PropTypes.string,
    isPublic: PropTypes.bool,
    publicClickAction: PropTypes.func
}

function mapStateToProps(state) {
    return {
        token: state.login.token
    }
}

export default connect(mapStateToProps, { followUser })(FollowBtn);